export { default } from './Ribbon';
